export interface ApiAdvAnnouncement {
  AccountId: number;
  AdvAnnouncementId: string;
  AppId: string;
  Created: string;
  Modified: string;
  Name: string;
  OrganizationId: string;
  RecordingId: string;
  RecordingName: string;
  RecordingNumber: string;
  TransferAddress?: string;
  TransferAddressId?: string;
  TransferAddressUsername?: string;
}

export interface AdvAnnouncement {
  accountId: number;
  advAnnouncementId: string;
  appId: string;
  created: string;
  modified: string;
  name: string;
  organizationId: string;
  recordingId: string;
  recordingName: string;
  recordingNumber: string;
  transferAddress?: string;
  transferAddressId?: string;
  transferAddressUsername?: string;
}

export function apiAdvAnnouncementToAdvAnnouncement(
  apiAdvAnnouncement: ApiAdvAnnouncement
): AdvAnnouncement {
  return {
    accountId: apiAdvAnnouncement.AccountId,
    advAnnouncementId: apiAdvAnnouncement.AdvAnnouncementId,
    appId: apiAdvAnnouncement.AppId,
    created: apiAdvAnnouncement.Created,
    modified: apiAdvAnnouncement.Modified,
    name: apiAdvAnnouncement.Name,
    organizationId: apiAdvAnnouncement.OrganizationId,
    recordingId: apiAdvAnnouncement.RecordingId,
    recordingName: apiAdvAnnouncement.RecordingName,
    recordingNumber: apiAdvAnnouncement.RecordingNumber,
    transferAddress: apiAdvAnnouncement.TransferAddress,
    transferAddressId: apiAdvAnnouncement.TransferAddressId,
    transferAddressUsername: apiAdvAnnouncement.TransferAddressUsername
  };
}
